import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, Router, UrlTree } from '@angular/router';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingSettings } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MaintenanceGuard implements CanActivate {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);

  canActivate(): Observable<boolean | UrlTree> {
    return this.http.get<CuttingSettings>(ApiLinks.cuttingSettings).pipe(
      map(settings => {
        if (settings.isMaintenanceInProgress) {
          return this.router.createUrlTree(['/maintenance'], {
            queryParams: { redirectUrl: this.router.url },
          });
        }
      })
    );
  }
}
